export default __webpack_public_path__ + "static/media/down_arrow.7472058c.svg";